/**
 * Who publishes these terms, as the trader identification a consumer-facing document has
 * to carry.
 *
 * **These are placeholders and must be filled in before the page goes live.** They are
 * deliberately empty rather than guessed: naming the wrong legal entity in a document
 * people accept is worse than naming none, and nobody but the operator knows the real
 * registration numbers.
 *
 * Empty fields are simply not drawn -- the same rule the footer applies to a clinic's
 * social links -- so a half-filled block still reads properly. A development-only warning
 * on the page itself flags the ones still missing; it never reaches a production build.
 *
 * Not translated, and not i18n keys: a company name and a CUI are the same in every
 * language. The *labels* beside them are translated, as `terms_contact_*`.
 */
export interface TermsOperator {
    /** Legal name, e.g. "EXAMPLE CLINIC SOFTWARE S.R.L." */
    legalName: string;
    /** Cod unic de înregistrare. */
    cui: string;
    /** Număr de ordine la registrul comerțului, e.g. "J40/1234/2026". */
    tradeRegister: string;
    /** Registered office, one line. */
    address: string;
    /** Where questions about these terms go. */
    email: string;
}

// TODO: fill these in before publishing the terms page.
export const termsOperator: TermsOperator = {
    legalName: '',
    cui: '',
    tradeRegister: '',
    address: '',
    email: '',
};

/** True while any identification field is still a placeholder. */
export const isOperatorIncomplete = (operator: TermsOperator): boolean =>
    Object.values(operator).some((value: string) => value.trim() === '');

/**
 * The consumer bodies a Romanian trader points at.
 *
 * The EU's online dispute resolution platform (`ec.europa.eu/consumers/odr`) is
 * deliberately absent, even though most Romanian sites still link it: it was switched off
 * on 20 July 2025 by Regulation (EU) 2024/3228, and traders are no longer required -- or
 * able -- to send anybody there.
 */
export const anpcUrl: string = 'https://anpc.ro/';

export const anpcSalUrl: string = 'https://anpc.ro/sal/';

/**
 * The day this text last changed. Bump it whenever the wording does -- it is the only
 * thing telling a reader which version they agreed to.
 */
export const termsLastUpdated: string = '2026-08-13';
